import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'leave-before-saving',
  templateUrl: './leave-before-saving.component.html',
  styleUrls: ['./leave-before-saving.component.css'],
  imports: [MatDialogModule, MatIconModule, MatButtonModule],
})
export class LeaveBeforeSavingComponent {}
